import { render, staticRenderFns } from "./EntrancePackageItemDetail.vue?vue&type=template&id=54e8d9a8"
import script from "./EntrancePackageItemDetail.vue?vue&type=script&lang=js"
export * from "./EntrancePackageItemDetail.vue?vue&type=script&lang=js"
import style0 from "./EntrancePackageItemDetail.vue?vue&type=style&index=0&id=54e8d9a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports